export function formatSize(bytes: number, decimals: number = 2): { isNegative: boolean; unit: string; value: number } {
  let isNegative = false;
  if ((!bytes && !Number.isFinite(bytes)) || bytes === 0) {
    return {
      value: 0,
      unit: "B",
      isNegative,
    };
  }

  if (bytes < 0) {
    isNegative = true;
  }
  const bytesAbsoluteValue = Math.abs(bytes);
  const kiloLimit = 1024;
  const decimalUsedInResult = Math.max(0, decimals);
  const sizes = ["B", "KiB", "MiB"];

  const i = Math.floor(Math.log(bytesAbsoluteValue) / Math.log(kiloLimit));
  return {
    value: parseFloat((bytesAbsoluteValue / kiloLimit ** i).toFixed(decimalUsedInResult)),
    unit: sizes[i],
    isNegative,
  };
}
